<template>
	<transition name="slide-fade">
		<v-container fluid>
			<v-layout wrap v-if="user.id">
				<v-flex xs12>
					<h3 class="text-center">User - {{ user.name }}</h3>
				</v-flex>
				<v-flex md6 sm6 xs12 class="pa-1">
					<!--  -->
				</v-flex>
				<v-flex md6 sm6 xs12 class="pa-1">
					<v-card>
						<v-card-title class="py-0">
							<v-spacer></v-spacer>Details
						</v-card-title>
						<v-card-text>
							<my-details header="Name">{{ user.name }}</my-details>
							<my-details header="Email">{{ user.email }}</my-details>
							<my-details header="Gender">{{ user.gender }}</my-details>
							<my-details header="Username">{{ user.username }}</my-details>
							<v-divider class="my-1 transparent"></v-divider>
							<my-details header="Activated">
								<v-btn small text title="Activate the user" @click="_activateUser(user)" v-if="!user.active">
									Activate
								</v-btn>
								<v-btn small text title="Deactivate user" @click="_deactivateUser(user)" v-else>
									Deactivate
								</v-btn>
							</my-details>
							<my-details header="Email Verified">
								<v-btn small text @click="_verify(user)" v-if="!user.email_verified_at">
									Verify
									<v-icon right>mdi-account-convert-outline</v-icon>
								</v-btn>
								<v-btn small text @click="_unverify(user)" v-else :title="user.email_verified_at">
									{{ moment(user.email_verified_at).fromNow() }}
									<v-icon right>mdi-account-convert-outline mdi-flip-h</v-icon>
								</v-btn>
							</my-details>
							<my-details header="Last Login">{{ user.last_login }}</my-details>
							<my-details header="" v-if="user.last_login">{{ moment(user.last_login).fromNow() }}</my-details>
							<my-details header="Last Address">{{ user.last_login_ip }}</my-details>
							<my-details>
								<mk-confirms-password content="Please confirm your password." @confirmed="_loginAs(user)">
									<v-btn text small class="" title="Login as this user" icon v-if="!user.is_admin">
										<v-icon>mdi-login</v-icon>
									</v-btn>
								</mk-confirms-password>
							</my-details>
							<my-details header="2-Factor Authentication" v-if="user.twofactor">
								<mk-confirms-password content="Please confirm your password to continue" @confirmed="disable2fa">
									<v-btn small color="error" outlined text title="Disable Two Factor Authentication for User">
										<v-icon left>mdi-two-factor-authentication</v-icon>Disable
									</v-btn>
								</mk-confirms-password>
							</my-details>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex md6 sm6 xs12 class="pa-1">
					<permissions :user="user"></permissions>
					<br>
					<v-card>
						<v-card-title class="py-0">
							<v-spacer></v-spacer>Attach Permission
						</v-card-title>
						<v-card-text>
							<v-form v-model="valid">
								<v-autocomplete label="Select Permission" return-object :items="permissions" item-text="name" item-value="id" v-model="permission.permission_id">
									<template v-slot:item="{ active, item, attrs, on }">
                    <v-list-item v-on="on" v-bind="attrs" #default="{ active }" two-line>
                      <v-list-item-action>
                      <v-checkbox :input-value="active"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          <span>{{ item.name }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span>{{ item.label }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
								</v-autocomplete>
								<v-btn small color="primary" @click="attachPerm(permission)" class="pull-right">Attach</v-btn><br>
							</v-form>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex md6 sm6 xs12 class="pa-1">
					<user-roles :user="user"></user-roles>
					<br>
					<v-card>
						<v-card-title class="py-0">
							<v-spacer></v-spacer>
							Attach Role
						</v-card-title>
						<v-card-text>
							<attach-role :user="user" :roles="roles"></attach-role>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
			<v-dialog v-model="resetPass">
        <v-card>
          <v-card-title class="teal white--text">
            <v-btn class="pa-0 mt-0" icon text @click="resetPass = false" title="Close">
              <v-icon>fa-arrow-left</v-icon>
            </v-btn>
            <h4 class="text-center">Change Password</h4>
          </v-card-title>
          <v-card-text>
            <form @submit.prevent="resetPassword(password)">
							<v-text-field name="Password" label="Password" hint="The password must be atleast 8 characters long and contain atleast one lowercase letter, one uppercase letter and one number" placeholder="aB3?5Fg!" v-model="password.password" min="8" :append-icon="e1 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e1 = !e1)" :type="e1 ? 'password' : 'text'" required  pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" maxlength="60" data-vv-name="Password" :rules="[rules.required, rules.password]" :error-messages="_error('password')"></v-text-field>
							<v-text-field name="ConfirmPassword" label="Confirm Password" hint="The password must be atleast 8 characters long and contain atleast one lowercase letter, one uppercase letter and one number" placeholder="aB3?5Fg!" v-model="password.password_confirmation" min="8" :append-icon="e1 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e1 = !e1)" :type="e1 ? 'password' : 'text'" required  pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" maxlength="60" data-vv-name="ConfirmPassword" :rules="[rules.required, rules.password, rules.confirmed]"></v-text-field>
							<v-btn type="submit" class="btn-primary pa-0" :disabled="true">Change Password</v-btn>
						</form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="pa-0" text @click="resetPass = false" title="Close">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
		</v-container>
	</transition>
</template>

<script>
	import layout from '@/Layouts/Admin'
  import MkConfirmsPassword from '@/Components/components/ConfirmsPassword.vue'
	const userRoles = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "admin" */ '@/Pages/Admin/users/roles.vue')
	const permissions = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "admin" */ '@/Pages/Admin/users/permissions.vue')
	const attachRole = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "admin" */ '@/Pages/Admin/users/attach-role.vue')
	const MyDetails = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/details.vue')

	export default {
		name: 'UserDetailsPage',
		layout,
		components: {
			userRoles,
			permissions,
			attachRole,
			MkConfirmsPassword,
			MyDetails
		},
		props: [
			'user', 'roles', 'permissions',
		],
		metaInfo () {
			return {
				title: 'User | ' + this.user.name
			}
		},
		data() {
			return {
				loading: true,
				resetPass: false,
				password: {
					password: '',
					password_confirmation: ''
				},
				rules: {
          required: (value) => !!value || 'This field is required.',
          email: (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Please enter a valid e-mail.'
          },
          password: (value) => {
          	const pattern2 = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
          	return pattern2.test(value) || 'Password pattern does not match the requested format'
          },
          confirmed: (v1) => {
            var v2 = this.password.password
            return v1 === v2 || "The Value don't match."
          }
				},
				e1: true,
				valid: true,
				permission: {
					permission_id: '',
				}
			}
		},
		methods: {
			resetPassword(password) {
				swal({
					title: 'Change Password for user?',
					text: '',
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: 'red',
					confirmButtonText:'Ok',
					closeOnConfirm: false,
					showLoaderOnConfirm: true
				},
				function(){
					this.$http.put('users/'+this.user.id+'/reset-password-admin', password)
					.then(response => {
						swal({title:'Password Reset Successful',type:'success', text: 'Inform the user of the change and have them change the password at their profile page'})
					})
					.catch(err => {
						swal('Error '+err.status+': '+err.statusText,'Failed to Reset Password','error')
					})
				}.bind(this))
			},
			removeMember (user) {
				swal({
					title: user.name,
					text: 'Remove user\'s '+ user.type + ' account?' ,
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: 'red',
					confirmButtonText:'Remove',
					closeOnConfirm: false,
					showLoaderOnConfirm: true,
				},
				function () {
					this.$http.post('users/' + user.id + '/member')
					.then(res => {
						this.$store.dispatch('users/users')
						.then(res => {
							this.fetchData()
						})
						swal('Account type removed')
					})
					.catch(err => {
						swal('Error '+err.status+': '+err.statusText, 'Failed to Remove', 'error')
					})
				}.bind(this))
			},
			attachPerm (permission) {
				swal({
					title: this.permission.permission_id,
					text: 'Attach this permission to ' + this.user.name + '<br>' + this.user.email,
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: 'red',
					confirmButtonText:'Attach',
					closeOnConfirm: false,
					showLoaderOnConfirm: true,
				},
				function () {
					this.$inertia.post('/admin/permissions/' + this.permission.permission_id.id + '/users/' + this.user.id + '/attach', {}, {
						preserveScroll: true,
						preserveState: true,
						onSuccess: () => {
							this.permission.permission_id = {}
							swal({ title: 'Attached', type: 'success', timer: 2500 })
						},
						onError: (err) => {
							swal('Failed. Try again later')
						}
					})
				}.bind(this))
			},
			disable2fa () {
				swal({
					title: 'Disable 2FA for ' + this.user.name + '?',
					text: '',
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: 'red',
					confirmButtonText:'Disable',
					closeOnConfirm: false,
					showLoaderOnConfirm: true
				},
				function(){
					this.$inertia.post('/admin/users/' + this.user.id + '/disable2fa', { id: this.user.id }, {
						preserveScroll: true,
						preserveState: true,
						onSuccess: () => {
							swal({ title: '2FA Disabled', type: 'success', timer: 2500 })
						},
						onError: (err) => {
							swal('Failed. Try again later')
						}
					})
				}.bind(this))
			},
		},
		beforeMount() {
			if (this.user && this.user.email && this.user.email.includes('mwatha.kinyua@hotmail.com')) {
				this.$inertia.visit('/admin/users')
			}
		},
		computed: {
			//
		},
		watch: {
			'user.email': function (value) {
				if (value.includes('mwatha.kinyua@hotmail.com')) {
					this.$inertia.visit('/admin/users')
				}
			},
			'e1': function () {
				if (!this.e1) {
					setTimeout(function() {
						this.e1 = true
					}.bind(this), 5000);
				}
			}
		}
	}
</script>

<style>
	/**/
</style>
